module.exports = __webpack_public_path__ + "img/dog-03-cycle.3c6d6de0.png";